import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

export default function UpdateNotification() {
  // 🔇 업데이트 팝업 비활성화 — 추후 관리자 공지 시스템으로 교체 예정
  return null;

  const [showUpdate, setShowUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    // 현재 버전 확인
    const currentVersion = localStorage.getItem('app_version');

    // 30초마다 버전 체크
    const checkVersion = async () => {
      try {
        const response = await fetch('/api/version');

        // 응답 상태 확인
        if (!response.ok) {
          console.warn('버전 체크 API 응답 오류:', response.status);
          return;
        }

        // Content-Type 확인
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn('버전 체크 API가 JSON이 아닌 응답 반환');
          return;
        }

        const data = await response.json();

        if (currentVersion && currentVersion !== data.version) {
          // 새 버전 감지
          setUpdateInfo(data);
          setShowUpdate(true);
        } else if (!currentVersion) {
          // 최초 실행
          localStorage.setItem('app_version', data.version);
        }
      } catch (error) {
        // 네트워크 오류 등은 조용히 무시 (사용자 경험 방해 방지)
        console.warn('버전 체크 실패 (무시됨):', error.message);
      }
    };

    // 즉시 체크
    checkVersion();

    // 30초마다 체크
    const interval = setInterval(checkVersion, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    setIsUpdating(true);

    // 새 버전 저장
    if (updateInfo) {
      localStorage.setItem('app_version', updateInfo.version);
    }

    // 강력 새로고침 (캐시 무시)
    setTimeout(() => {
      window.location.reload(true);
    }, 500);
  };

  const handleDismiss = () => {
    // 새 버전 저장 (다시 알림 안 뜨도록)
    if (updateInfo) {
      localStorage.setItem('app_version', updateInfo.version);
    }
    setShowUpdate(false);
  };

  if (!showUpdate || !updateInfo) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* 헤더 */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <RefreshCw className="w-6 h-6 text-white" />
            <h2 className="text-xl font-bold text-white">새로운 업데이트</h2>
          </div>
          <button
            onClick={handleDismiss}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded p-1 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* 내용 */}
        <div className="p-6">
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-sm text-gray-500">버전</span>
              <span className="text-lg font-bold text-blue-600">{updateInfo.version}</span>
              <span className="text-sm text-gray-400">({updateInfo.date})</span>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">📝 업데이트 내용</h3>
            <ul className="space-y-2">
              {updateInfo.changes.map((change, index) => (
                <li key={index} className="text-sm text-gray-600 pl-4 relative">
                  <span className="absolute left-0">•</span>
                  {change}
                </li>
              ))}
            </ul>
          </div>

          {/* 버튼 */}
          <div className="flex gap-3">
            <button
              onClick={handleUpdate}
              disabled={isUpdating}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isUpdating ? (
                <>
                  <RefreshCw className="w-4 h-4 animate-spin" />
                  업데이트 중...
                </>
              ) : (
                <>
                  <RefreshCw className="w-4 h-4" />
                  지금 업데이트
                </>
              )}
            </button>
            <button
              onClick={handleDismiss}
              className="px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition"
            >
              나중에
            </button>
          </div>

          <p className="text-xs text-gray-400 mt-4 text-center">
            업데이트를 적용하려면 페이지가 새로고침됩니다
          </p>
        </div>
      </div>
    </div>
  );
}

